<template>
    <section class="categories-list">
        <div class="content">
            <PrismicRichText :field="slice.primary.title" class="title" />
            <div class="categories">
                <CategoryCard v-for="category in CATEGORIES" :key="category" :category="category" class="card" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import type {CategoriesListSlice} from '@prismicio-types';
    import {CATEGORIES} from '~/app/keys';
    import CategoryCard from '~/components/CategoryCard.vue';
    defineProps({...getSliceComponentProps<CategoriesListSlice>()});
</script>

<style lang="scss">
    @use '~/assets/styles/variables' as *;

    .categories-list {
        padding-bottom: 100px;

        @media (max-width: $tablet-breakpoint) {
            padding-bottom: 50px;
        }

        .title {
            padding-top: 20px;

            h2 {
                color: var(--joy-color-primary-50);
                font-family: var(--joy-font-family-title);
                font-weight: var(--joy-font-weight-normal);
                font-size: var(--joy-font-size-secondary-200);
                margin-bottom: var(--joy-core-spacing-9);

                @media (max-width: $tablet-breakpoint) {
                    margin-bottom: var(--joy-core-spacing-4);
                }
            }
        }

        .content {
            overflow: auto hidden;

            @include content-width;

            .categories {
                display: grid;
                grid-template-columns: repeat(4, 1fr);

                @media (max-width: $tablet-breakpoint) {
                    grid-template-columns: repeat(2, 1fr);
                }

                @media (max-width: $mobile-breakpoint) {
                    grid-template-columns: 1fr;
                }

                .card {
                    padding: 30px 25px;
                    border-top: solid 1px var(--joy-color-neutral-30);
                    border-right: solid 1px var(--joy-color-neutral-30);

                    &:first-child,
                    &:nth-child(2),
                    &:nth-child(3),
                    &:nth-child(4) {
                        border-top: none;
                    }

                    &:nth-child(4n) {
                        border-right: none;
                    }

                    &:last-child {
                        border-right: none;
                    }

                    @media (max-width: $tablet-breakpoint) {
                        &:nth-child(3),
                        &:nth-child(4) {
                            border-top: solid 1px var(--joy-color-neutral-30);
                        }

                        &:nth-child(2n) {
                            border-right: none;
                        }
                    }

                    @media (max-width: $mobile-breakpoint) {
                        padding: 30px 0;
                        border-left: none;
                        border-right: none;
                        border-top: solid 1px var(--joy-color-neutral-30);

                        &:nth-child(2) {
                            border-top: solid 1px var(--joy-color-neutral-30);
                        }

                        &:first-child {
                            border-top: none;
                        }
                    }
                }
            }
        }
    }
</style>
